import DashboardComponentWrapper from "../../components/DashboardComponentWrapper";
import { useNavigate } from "react-router-dom";
import { images } from "../../assets";
import { setSelectedProduct } from "../../actions/authActions";
import { useState, useEffect } from "react";
import { getEmployers } from "../../actions/employer";
import PageLoader from "../../components/PageLoader";
import { useAppSelector } from "../../app/hooks";
import useFeature from "../../hooks/useFeature";

const ProductList = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const employersList = useAppSelector((state) => state.employers.employers);
    useEffect(() => {
        employersList.length === 0 && getEmployers(() => {
            setLoading(false);
        }, true);
    }, []);
    const showSalary = useFeature('salary');


    const data: Array<Record<string, any>> = [
        {
            title: 'Remit Pensions',
            label: 'Pension',
            description: 'Easily remit pension payments according to your schedules.',
            link: '/dashboard/overview',
            linkHandler: () => {
                setSelectedProduct({
                    value: '/dashboard/overview',
                    label: 'Pension'
                });
                if (employersList.length === 0) {
                    navigate('/dashboard/overview');
                } else {
                    navigate('/pension/select_employer');
                }
            },
            linkText: 'Get Started',
            color: '#0898A01A',
            img: images.payment,
            textColor: '',
        },
    ];
    if (showSalary) {
        data.push(
            {
                title: 'Pay Salary',
                description: 'Easily make salary payments according to your schedules.',
                link: '/salary',
                label: 'Salary',
                linkText: 'Get Started',
                color: '#0898A01A',
                img: images.salary,
                textColor: '',
            },
        );
    }
    if (loading) return <PageLoader />
    return (
        <DashboardComponentWrapper
            subTitle={``}
            pageDetails=""
        >
            <div className="w-full flex flex-col justify-start items-center pb-10 min-h-screen">
                <div className="mb-6">
                    <p className="text-4xl">Welcome to PenSphere</p>
                    <p className="text-lg my-2">What would you like to do on PenSphere today?</p>
                </div>
                <div className="w-[90%] xl:w-[70%] my-6 flex flex-row flex-wrap items-center justify-center gap-6">
                    {
                        data.map((itm) => (
                            <div key={itm.title} onClick={() => {
                                if (itm.linkHandler) {
                                    itm.linkHandler();
                                    return;
                                }
                                setSelectedProduct({
                                    value: itm.link,
                                    label: itm.label
                                });
                                itm.link && navigate(itm.link);
                            }} className="cursor-pointer">
                                <div
                                    className={`min-h-[400px] h-fit w-full flex flex-col justify-start items-start p-8 rounded-md relative`}
                                    style={{
                                        backgroundColor: itm.color,
                                        color: itm.textColor,
                                    }}
                                >
                                    <p className="text-2xl capitalize">{itm.title}</p>
                                    <p className="text-left text-sm my-4">{itm.description}</p>
                                    {
                                        itm.linkText && (
                                            <button className="!w-fit pr-10 bg-az-teal text-white rounded h-9 !pl-4 text-sm flex flex-row justify-start items-center capitalize">
                                                {itm.linkText}
                                                <svg className="ml-3" xmlns="http://www.w3.org/2000/svg" width="16" height="13" viewBox="0 0 16 13" fill="none">
                                                    <path d="M14.2812 6.25977L1.15625 6.25977" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M8.9873 0.988374L14.2811 6.25937L8.9873 11.5312" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </button>
                                        )
                                    }
                                    {
                                        itm.img && (
                                            <img
                                                loading="lazy"
                                                src={itm.img} alt=""
                                                className="h-[150px] absolute bottom-0 self-center object-contain"
                                            />
                                        )
                                    }
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </DashboardComponentWrapper>
    )
};

export default ProductList;
